/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Hightouch.Spelling = NO -->*/
/*<!-- vale Hightouch.Substitutions = NO -->*/
/*<!-- vale Hightouch.Spelling = YES -->*/
/*<!-- vale Hightouch.Substitutions = YES -->*/
/*<!-- vale Google.Headings = NO -->*/
/*<!-- vale Google.Headings = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1790035200000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Sep 22 2026 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "marketo",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Marketo setup",
          "depth": 0,
          "id": "marketo-setup"
        }, {
          "value": "Create Marketo service",
          "depth": 1,
          "id": "create-marketo-service"
        }, {
          "value": "Connect to Marketo",
          "depth": 0,
          "id": "connect-to-marketo"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing objects",
          "depth": 1,
          "id": "syncing-objects"
        }, {
          "value": "Syncing custom activities",
          "depth": 1,
          "id": "syncing-custom-activities"
        }, {
          "value": "Syncing static lists",
          "depth": 1,
          "id": "syncing-static-lists"
        }, {
          "value": "Trigger campaigns",
          "depth": 1,
          "id": "trigger-campaigns"
        }, {
          "value": "Tips and troubleshooting",
          "depth": 0,
          "id": "tips-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      h3: "h3",
      h4: "h4",
      ol: "ol",
      li: "li",
      img: "img",
      code: "code",
      ul: "ul"
    }, _provideComponents(), props.components), {PremiumDestination, CommonErrorsPreface, LiveDebugger, SyncAlerts} = _components;
    if (!CommonErrorsPreface) _missingMdxReference("CommonErrorsPreface", true);
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!PremiumDestination) _missingMdxReference("PremiumDestination", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(PremiumDestination, {
        destinationName: "Marketo"
      }), "\n", _jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Standard and custom objects"
              })
            }), _jsx(_components.td, {
              children: "Sync data to custom or standard objects including leads, companies, and opportunities"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/lead-database/custom-objects",
                children: "Object docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Custom activities"
              })
            }), _jsx(_components.td, {
              children: "Sync data to custom activities"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/lead-database/activities",
                children: "Activities docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Static lists"
              })
            }), _jsx(_components.td, {
              children: "Update membership in static lists"
            }), _jsx(_components.td, {
              children: "Add, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/assets/static-lists",
                children: "Static lists docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Campaign triggers"
              })
            }), _jsx(_components.td, {
              children: "Trigger campaigns using source data"
            }), _jsx(_components.td, {
              children: "Insert"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/assets/smart-campaigns",
                children: "Campaign docs"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "marketo-setup",
        children: "Marketo setup"
      }), "\n", _jsxs(_components.p, {
        children: ["Giving Hightouch access to Marketo's API requires you to create a ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/custom-services",
          children: _jsx(_components.strong, {
            children: "Custom Service"
          })
        }), " and ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/custom-services",
          children: _jsx(_components.strong, {
            children: "API Only User"
          })
        }), " for that service in Marketo.\nEven if you already have a Marketo API User, it's best to create one that's solely for the Hightouch service you'll create.\nHaving a dedicated user for the Hightouch integration lets you more easily track changes from Hightouch syncs."]
      }), "\n", _jsx(_components.h3, {
        id: "create-marketo-service",
        children: "Create Marketo service"
      }), "\n", _jsxs(_components.p, {
        children: ["Before you can create a Custom Service, you need to create a Marketo ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/custom-services",
          children: "role"
        }), " with API Access and a user with that role.\nNone of the default Marketo Roles have API access, so if this is your first API integration in Marketo, you first need to create an API access role."]
      }), "\n", _jsx(_components.h4, {
        id: "create-marketo-api-access-role",
        children: "Create Marketo API access role"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["In Marketo, go to ", _jsx(_components.strong, {
            children: "Admin > Users & Roles > Roles"
          }), " and click ", _jsx(_components.strong, {
            children: "New Role"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-new-role.png",
          alt: "Role creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsxs(_components.li, {
          children: ["Enter a ", _jsx(_components.strong, {
            children: "Role Name"
          }), " (for example, \"Hightouch Integration Role\") and ", _jsx(_components.strong, {
            children: "Description"
          }), ". Then assign ", _jsx(_components.strong, {
            children: "all"
          }), " permissions listed in this table to the role:"]
        }), "\n"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Sync Type"
            }), _jsx(_components.th, {
              children: "Necessary permissions"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Standard and custom objects"
              })
            }), _jsxs(_components.td, {
              children: [_jsx(_components.strong, {
                children: "Read-Write Company"
              }), " (for company objects), ", _jsx(_components.strong, {
                children: "Read-Write Opportunity"
              }), " (for opportunities), ", _jsx(_components.strong, {
                children: "Read-Write Person"
              }), " (for leads), and ", _jsx(_components.strong, {
                children: "Read-Write Custom Object"
              }), " and ", _jsx(_components.strong, {
                children: "Read-Write Custom Object Type"
              }), " (for any custom objects)"]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Custom activities"
              })
            }), _jsxs(_components.td, {
              children: [_jsx(_components.strong, {
                children: "Read-Write Activity"
              }), ", ", _jsx(_components.strong, {
                children: "Read-Write Activity Metadata"
              })]
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Static lists"
              })
            }), _jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Access Marketing Activities > List Import"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Campaign triggers"
              })
            }), _jsxs(_components.td, {
              children: [_jsx(_components.strong, {
                children: "Read-Write Assets"
              }), ", ", _jsx(_components.strong, {
                children: "Activate Campaign"
              })]
            })]
          })]
        })]
      }), "\n", _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsxs(_components.li, {
          children: ["Click ", _jsx(_components.strong, {
            children: "Create"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["If you try setting up a Marketo destination with an API access role that\nwasn't assigned ", _jsx(_components.strong, {
            children: "all"
          }), " permissions in the table above, the destination setup\nfails with a ", _jsx(_components.a, {
            href: "#code-603-access-denied",
            children: _jsx(_components.code, {
              children: "603 - Access denied"
            })
          }), " error."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "create-marketo-api-user",
        children: "Create Marketo API user"
      }), "\n", _jsx(_components.p, {
        children: "After creating a role, you need to create an API-Only user.\nAPI-Only users are a special type of user in Marketo, as they are administrated by other users and cannot be used to log in to Marketo."
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["In Marketo, go to ", _jsx(_components.strong, {
            children: "Admin > Users & Roles > Users"
          }), " and click ", _jsx(_components.strong, {
            children: "Invite New User"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-invite-new-user.png",
          alt: "User creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsxs(_components.li, {
          children: ["Enter an ", _jsx(_components.strong, {
            children: "email"
          }), " address, ", _jsx(_components.strong, {
            children: "first name"
          }), ", and ", _jsx(_components.strong, {
            children: "last name"
          }), " for the user. (These don't need to be valid.) Click ", _jsx(_components.strong, {
            children: "Next"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-invite-new-user-info.png",
          alt: "User creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsxs(_components.li, {
          children: ["Assign the ", _jsx(_components.a, {
            href: "#create-marketo-api-access-role",
            children: "previously created role"
          }), ", click the ", _jsx(_components.strong, {
            children: "API Only"
          }), " checkbox, and click ", _jsx(_components.strong, {
            children: "Next"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-invite-new-user-permissions.png",
          alt: "User creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsxs(_components.li, {
          children: ["The last screen for user creation says \"An invitation is not required for API only.\" Click ", _jsx(_components.strong, {
            children: "Send"
          }), " to create the API-Only user."]
        }), "\n"]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Ensure that this user has access to the ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/en/docs/marketo/using/product-docs/administration/workspaces-and-person-partitions/understanding-workspaces-and-person-partitions",
            children: "workspaces and\npartitions"
          }), "\nyou want to use in Hightouch. You can read more about this in the ", _jsx(_components.a, {
            href: "#code-603-access-denied",
            children: _jsx(_components.code, {
              children: "603 -   Access denied"
            })
          }), " section."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "create-a-custom-service",
        children: "Create a custom service"
      }), "\n", _jsx(_components.p, {
        children: "Custom Services provide the actual credentials required to authenticate Marketo to Hightouch.\nTo provision one, follow these instructions:"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["In Marketo, go to ", _jsx(_components.strong, {
            children: "Admin > LaunchPoint"
          }), " and select ", _jsx(_components.strong, {
            children: "New Service"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-new-service.png",
          alt: "Service creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "2",
        children: ["\n", _jsxs(_components.li, {
          children: ["Give your service a descriptive name. From the ", _jsx(_components.strong, {
            children: "Service"
          }), " list, select the ", _jsx(_components.strong, {
            children: "Custom"
          }), ". Give your service a description, for example, \"Hightouch Integration\" and select ", _jsx(_components.a, {
            href: "#create-marketo-api-user",
            children: "the API Only user you previously created"
          }), ", then click ", _jsx(_components.strong, {
            children: "Create"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-new-service-config.png",
          alt: "Service creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "3",
        children: ["\n", _jsxs(_components.li, {
          children: ["This adds a new service to your list of LaunchPoint services, and the option to ", _jsx(_components.strong, {
            children: "View Details"
          }), ". Click on ", _jsx(_components.strong, {
            children: "View Details"
          }), " and save the ", _jsx(_components.strong, {
            children: "Client Id"
          }), " and ", _jsx(_components.strong, {
            children: "Client Secret"
          }), " for use in Hightouch."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-service-details.png",
          alt: "Service creation in the Marketo UI"
        })
      }), "\n", _jsx(_components.p, {
        children: "You're now ready to provide Hightouch access to Marketo."
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-marketo",
        children: "Connect to Marketo"
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["If you created an ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/administration/additional-integrations/create-an-allowlist-for-ip-based-api-access.html",
            children: "IP\nAllowlist"
          }), "\nin your Marketo settings, make sure to allowlist Hightouch IP addresses so\nHightouch can reach your cluster. Refer to our ", _jsx(_components.a, {
            href: "/security/networking#ip-addresses",
            children: "IP address\ndocs"
          }), " to find the relevant IP addresses for\nyour Hightouch region."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["In Hightouch, go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations?from=docs",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Marketo"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ". You can then authenticate Hightouch to Marketo by entering the following fields:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Client ID"
        }), "\n", _jsx(_components.li, {
          children: "Client Secret"
        }), "\n", _jsx(_components.li, {
          children: "Base URL"
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["To find the Client ID and Secret, navigate to ", _jsx(_components.strong, {
          children: "Admin > LaunchPoint"
        }), " in your Marketo account and select ", _jsx(_components.a, {
          href: "#create-marketo-service",
          children: "the service you created for Hightouch"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-service-details.png",
          alt: "Service creation in the Marketo UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can find the Base URL in ", _jsx(_components.strong, {
          children: "Admin > Integration > Web Services"
        }), " under ", _jsx(_components.strong, {
          children: "REST API"
        }), ".\nOnly use the part after ", _jsx(_components.code, {
          children: "https://"
        }), " and before ", _jsx(_components.code, {
          children: "/rest"
        }), " as your base URL, for example, ", _jsx(_components.code, {
          children: "663-XSQ-200.mktorest.com"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-base-url.png",
          alt: "Base URL in the Marketo UI"
        })
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Marketo destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs?from=docs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Marketo destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-objects",
        children: "Syncing objects"
      }), "\n", _jsx(_components.p, {
        children: "Hightouch supports syncing to both standard and custom Marketo objects.\nThe standard objects that Hightouch supports are:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Leads"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Companies"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.strong, {
            children: "Opportunities"
          })
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["You can match rows from your model to objects in Marketo on any column in your model and certain fields in Marketo. To avoid duplications or other data issues, it's imperative to choose a column with unique values. Refer to the ", _jsx(_components.a, {
          href: "/syncs/record-matching",
          children: "record matching docs"
        }), " for more information."]
      }), "\n", "\n", "\n", _jsx(_components.p, {
        children: "The Marketo fields available for record matching depend on the object:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["for the ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/lead-database/lead-database",
            children: "Lead object"
          }), ", Hightouch lists all ", _jsx(_components.code, {
            children: "person"
          }), " type ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/administration/field-management/create-a-custom-field-in-marketo.html",
            children: "custom fields"
          }), " for record matching,"]
        }), "\n", _jsxs(_components.li, {
          children: ["for ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/administration/marketo-custom-objects/understanding-marketo-custom-objects.html",
            children: "custom objects"
          }), ", ", _jsx(_components.a, {
            href: "#supported-syncing",
            children: "Upsert"
          }), " mode lists all ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/administration/marketo-custom-objects/add-marketo-custom-object-fields.html",
            children: "dedupe fields"
          }), ", whereas ", _jsx(_components.a, {
            href: "#supported-syncing",
            children: "Update"
          }), " mode lists all dedupe fields and ", _jsx(_components.code, {
            children: "MarketoGUID"
          }), "."]
        }), "\n"]
      }), "\n", "\n", "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you sync object fields via ", _jsx(_components.a, {
          href: "/syncs/mapping-data",
          children: "field mapping"
        }), ".\nYou can map data from any of your model columns to an object's default fields.\nEnsure your model columns data types match the data types of the fields you want to sync to."]
      }), "\n", _jsx(_components.h4, {
        id: "delete-behavior",
        children: "Delete behavior"
      }), "\n", _jsxs(_components.p, {
        children: ["The ", _jsx(_components.a, {
          href: "/syncs/overview#delete-behavior",
          children: "delete behavior"
        }), " you select dictates what to do when a row no longer appears in your model's query results. You have the following options:"]
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Behavior"
            }), _jsx(_components.th, {
              children: "Description"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Do nothing"
              })
            }), _jsx(_components.td, {
              children: "Keep the record in Marketo with all its synced fields"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Delete record"
              })
            }), _jsx(_components.td, {
              children: "Delete the record from Marketo"
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Clear fields"
              })
            }), _jsx(_components.td, {
              children: "Keep the record, but clear the mapped fields"
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["In Upsert mode, you can select between ", _jsx(_components.strong, {
          children: "Do nothing"
        }), " and ", _jsx(_components.strong, {
          children: "Delete record"
        }), ". In Update mode, you can select between ", _jsx(_components.strong, {
          children: "Do nothing"
        }), " and ", _jsx(_components.strong, {
          children: "Clear fields"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "batch-size",
        children: "Batch size"
      }), "\n", _jsxs(_components.p, {
        children: ["By default, Hightouch sends 300 objects in a batch.\nYou can lower the batch size to mitigate ", _jsx(_components.a, {
          href: "#code-413-request-entity-too-large",
          children: "413 Request Entity Too Large"
        }), " errors."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-custom-activities",
        children: "Syncing custom activities"
      }), "\n", _jsxs(_components.p, {
        children: ["When syncing custom activities, Hightouch treats any records added to your ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " as new activities and sends them to Marketo when your sync runs."]
      }), "\n", _jsxs(_components.p, {
        children: ["To sync custom activities, the custom activity type must first be created and approved in Marketo.\nYou can learn more about creating custom activities in ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/administration/marketo-custom-activities/create-a-custom-activity.html",
          children: "Marketo's docs"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "activity-selection",
        children: "Activity selection"
      }), "\n", _jsxs(_components.p, {
        children: ["To start, select a custom activity type you've already created in Marketo.\nIf you don't see it in the dropdown, make sure it's approved in Marketo and then click ", _jsx(_components.strong, {
          children: "Refresh"
        }), " in Hightouch."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-activity-selection.png",
          alt: "Custom activity sync configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "event-timestamp",
        children: "Event timestamp"
      }), "\n", _jsx(_components.p, {
        children: "You can optionally select a column that contains timestamps of when activities occurred. If this field is empty, Marketo uses the time the activity arrives at the server."
      }), "\n", _jsx(_components.h4, {
        id: "lead-matching",
        children: "Lead matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To associate activities to leads, select the model column that contains either the leads' ", _jsx(_components.strong, {
          children: "Marketo GUID"
        }), " or ", _jsx(_components.strong, {
          children: "Email"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-activity-lead.png",
          alt: "Custom activity sync configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "activity-primary-attribute",
        children: "Activity primary attribute"
      }), "\n", _jsxs(_components.p, {
        children: ["Select the model column to map to the ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/lead-database/activities",
          children: "primary attribute field"
        }), " for your custom activity."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-activity-record-matching.png",
          alt: "Custom activity sync configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can also map data from any of your model columns to a custom activity's non-primary attributes.\nEnsure your model columns data types match the data types of the fields you want to sync to."
      }), "\n", _jsx(_components.h3, {
        id: "syncing-static-lists",
        children: "Syncing static lists"
      }), "\n", _jsx(_components.p, {
        children: "Static lists are a list of names in Marketo.\nYou can configure Hightouch syncs to manage these lists by adding and updating users."
      }), "\n", _jsx(_components.h4, {
        id: "user-identifiers",
        children: "User identifiers"
      }), "\n", _jsxs(_components.p, {
        children: ["To identify which users to add or update in an static list, select a model column and the corresponding Marketo attribute, for example ", _jsx(_components.strong, {
          children: "Lead ID"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "select-an-existing-static-list-or-create-a-new-one",
        children: "Select an existing static list or create a new one"
      }), "\n", _jsx(_components.p, {
        children: "You can create a new static list or use an existing one. When creating a new static list, you can optionally enter a name; otherwise, Hightouch defaults to the name of the associated model. To use an existing static list, select the desired static list from the dropdown."
      }), "\n", _jsx(_components.p, {
        children: "The existing list dropdown searches by the list's exact, full name or its numeric Marketo ID. Partial names aren't supported because Marketo's API only matches full names. If you have many lists with similar names, you can optionally select a folder or program first; the dropdown then only shows that folder or program's lists, and you can filter them by partial name."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-list-create.png",
          alt: "Static list sync configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "folder-selection",
        children: "Folder selection"
      }), "\n", _jsx(_components.p, {
        children: "If you're creating a new static list in Marketo, you need to select the folder/program to create the list in. Search for it by its exact, full name or numeric ID; partial names aren't supported. Static lists can only be created in\nfolders and programs of the following types:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Email Batch Program"
        }), "\n", _jsx(_components.li, {
          children: "Marketing Program"
        }), "\n", _jsx(_components.li, {
          children: "Nurture Program"
        }), "\n", _jsx(_components.li, {
          children: "List"
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "In the Marketo UI, you can tell whether the folder is one of the above types by right clicking the folder in the Marketing Activities sidebar. If the \"New local asset\"\nor \"Create list\" options are available, then the folder supports static lists."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destinations-marketo-new-local-asset.png",
          alt: "New local asset in Marketo UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "static-list-description",
        children: "Static list description"
      }), "\n", _jsx(_components.p, {
        children: "If you're creating a new static list in Marketo, you can optionally Hightouch add a description for the static list."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-list-description.png",
          alt: "Static list sync configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "split-retries",
        children: "Split retries"
      }), "\n", _jsxs(_components.p, {
        children: ["By default, Hightouch retries all records in a rejected batch. To pinpoint which users are getting rejected with which errors and reduce the number of valid users that get retried, you can enable ", _jsx(_components.a, {
          href: "/syncs/retries#split-retries",
          children: "split retries"
        }), "."]
      }), "\n", _jsx(_components.h3, {
        id: "trigger-campaigns",
        children: "Trigger campaigns"
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch lets you use records from your models to trigger campaigns through the ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/endpoint-reference",
          children: "Marketo Campaign API"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "prerequisites",
        children: "Prerequisites"
      }), "\n", _jsxs(_components.p, {
        children: ["Before you can set up a Hightouch sync to trigger a campaign, you need to have an active ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo/using/product-docs/core-marketo-concepts/smart-campaigns/creating-a-smart-campaign/understanding-batch-and-trigger-smart-campaigns",
          children: "trigger campaign"
        }), " with ", _jsx(_components.strong, {
          children: "Web Service API"
        }), " as the source in Marketo.\nFor details, follow the setup instructions below."]
      }), "\n", _jsx(_components.h4, {
        id: "trigger-campaign-setup",
        children: "Trigger campaign setup"
      }), "\n", _jsxs(_components.ol, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["If you haven't already, go to ", _jsx(_components.strong, {
              children: "Design Studio"
            }), " to ", _jsx(_components.a, {
              href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/email-marketing/general/email-editor-2/create-an-email-template.html",
              children: "draft an email template"
            }), " in your Marketo instance. Before your email template you can use the email template in Hightouch, your draft must be approved."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-marketo-trigger-email.png",
              alt: "Email template creation in Marketo"
            })
          }), "\n", _jsxs(_components.p, {
            children: ["You can use custom ", _jsx(_components.a, {
              href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/demand-generation/landing-pages/personalizing-landing-pages/tokens-overview.html",
              children: "tokens"
            }), " to populate your email template with data from your model."]
          }), "\n", _jsx(_components.p, {
            children: _jsx(_components.img, {
              src: "destinations/destination-marketo-trigger-email-tip.png",
              alt: "Email template creation in Marketo"
            })
          }), "\n", _jsx(_components.p, {
            children: "In the example screenshot above, a custom token makes it possible to dynamically populate the email subject."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Next, you need a ", _jsx(_components.strong, {
              children: "Smart Campaign"
            }), " to trigger. Follow ", _jsx(_components.a, {
              href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/core-marketo-concepts/smart-campaigns/creating-a-smart-campaign/create-a-new-smart-campaign.html?lang=en",
              children: "these steps"
            }), " if you need to create a new one. Make sure that your campaign belongs to a program."]
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsxs(_components.p, {
            children: ["Open the ", _jsx(_components.strong, {
              children: "Smart List"
            }), " tab in the top nav to configure the trigger. Drag and drop ", _jsx(_components.strong, {
              children: "Campaign is Requested"
            }), " from the triggers list on the right."]
          }), "\n"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-smart-campaign.png",
          alt: "Campaign trigger setup in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "4",
        children: ["\n", _jsxs(_components.li, {
          children: ["Select that the source ", _jsx(_components.strong, {
            children: "is"
          }), " ", _jsx(_components.strong, {
            children: "Web Service API"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-smart-campaign-source.png",
          alt: "Campaign trigger setup in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "5",
        children: ["\n", _jsxs(_components.li, {
          children: ["Open the ", _jsx(_components.strong, {
            children: "Flow"
          }), " tab in the top nav to configure your flow. Drag and drop ", _jsx(_components.strong, {
            children: "Send Email"
          }), " from the actions on the right."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-send-email.png",
          alt: "Flow setup in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "6",
        children: ["\n", _jsx(_components.li, {
          children: "Select the email template you want to send."
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-smart-campaign-flow.png",
          alt: "Flow setup in the Marketo UI"
        })
      }), "\n", _jsxs(_components.ol, {
        start: "7",
        children: ["\n", _jsxs(_components.li, {
          children: ["Open the ", _jsx(_components.strong, {
            children: "Schedule"
          }), " tab in the top nav to configure your qualifications. Click on ", _jsx(_components.strong, {
            children: "Edit"
          }), " to edit your qualifications."]
        }), "\n"]
      }), "\n", _jsx(Warning, {
        children: _jsxs(_components.p, {
          children: ["Hightouch doesn't check if an email has been sent to a distinct lead before\ntrigger a campaign. For example, if a lead with email ", _jsx(_components.code, {
            children: "janedoe@example.com"
          }), "\nappears in two of the queried rows from your model, then Hightouch triggers an\nemail for each of these rows. Two emails would be sent to\n", _jsx(_components.code, {
            children: "janedoe@example.com"
          }), ". If you want to only send one email per lead, set your\nqualifications in Marketo to ", _jsx(_components.strong, {
            children: "only once"
          }), ". ", _jsx(_components.img, {
            src: "destinations/destination-marketo-trigger-qualifications.png",
            alt: "Flow setup in the Marketo\nUI"
          })]
        })
      }), "\n", _jsxs(_components.ol, {
        start: "8",
        children: ["\n", _jsxs(_components.li, {
          children: ["Click ", _jsx(_components.strong, {
            children: "Activate"
          }), " when you're finished."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-smart-campaign-schedule.png",
          alt: "Campaign activation"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["For additional reference, see ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/marketo-developer/marketo/rest/assets/transactional-email",
          children: "Marketo's how-to article"
        }), "."]
      }), "\n", _jsx(_components.h4, {
        id: "sync-configuration-1",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Each new row in your model triggers your Marketo Smart Campaign.\nThat means that Hightouch triggers the campaign for every row in your model on your first sync run, or if you trigger a ", _jsx(_components.a, {
          href: "/syncs/overview#resync-full-query",
          children: "full resync"
        }), ".\nIn subsequent sync runs, only new rows in your model's query results trigger the campaign."]
      }), "\n", _jsx(_components.h4, {
        id: "campaign-selection",
        children: "Campaign selection"
      }), "\n", _jsxs(_components.p, {
        children: ["To start, select a campaign you've created in Marketo.\nOnly campaigns triggerable via web service API are listed here.\nIf you don't see the campaign you want to trigger in the dropdown, make sure it's follows the ", _jsx(_components.a, {
          href: "#prerequisites",
          children: "prerequisites"
        }), " and then click ", _jsx(_components.strong, {
          children: "Refresh"
        }), " in Hightouch."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-campaign-selection.png",
          alt: "Campaign trigger configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "lead-matching-1",
        children: "Lead matching"
      }), "\n", _jsxs(_components.p, {
        children: ["Marketo Smart Campaigns can only be triggered for leads that already exist in your Marketo instance.\nTo trigger an email for the intended leads, select the model column that contains either the leads' ", _jsx(_components.strong, {
          children: "Marketo GUID"
        }), " or ", _jsx(_components.strong, {
          children: "Email"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-activity-lead.png",
          alt: "Campaign trigger configuration in the Hightouch UI"
        })
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["If you use email for your lead matching and your leads aren't de-duplicated by\nemail, Hightouch uses the latest lead based on the ", _jsx(_components.code, {
            children: "createdAt"
          }), " timestamp."]
        })
      }), "\n", _jsx(_components.h4, {
        id: "token-mappings",
        children: "Token mappings"
      }), "\n", _jsx(_components.p, {
        children: "Use this section to map custom token values.\nYou only need to add mappings for tokens used in your email template."
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-tokens.png",
          alt: "Campaign trigger configuration in the Hightouch UI"
        })
      }), "\n", _jsx(_components.h4, {
        id: "testing",
        children: "Testing"
      }), "\n", _jsx(_components.p, {
        children: "Before activating your campaign trigger sync, it's best to test it with with an example lead whose email inbox you have access to.\nThis lets you inspect the test email."
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Test"
        }), " from the sync configuration page."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-test.png",
          alt: "Testing a campaign trigger sync"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["You can manually overwrite columns of a test row.\nIn the example below, since the sync uses the ", _jsx(_components.strong, {
          children: "Email"
        }), " column to match leads, you can manually overwrite the ", _jsx(_components.strong, {
          children: "Email"
        }), " field to test lead's email address."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-test-edit.png",
          alt: "Testing a campaign trigger sync"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["If you're using the ", _jsx(_components.strong, {
          children: "Marketo GUID"
        }), " column to match leads, you need to manually overwrite the ", _jsx(_components.strong, {
          children: "Marketo GUID"
        }), " field to the test lead's ", _jsx(_components.strong, {
          children: "Marketo GUID"
        }), " to send a test email."]
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've altered the email or Marketo GUID, press ", _jsx(_components.strong, {
          children: "Sync as added row"
        }), ". This triggers the campaign for the test lead and sends an email to their inbox."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "destinations/destination-marketo-trigger-test-sync-as-added-row.png",
          alt: "Testing a campaign trigger sync"
        })
      }), "\n", _jsx(_components.p, {
        children: "Check the test lead's email inbox to verify that your configuration sent the intended email with custom tokens populated as expected."
      }), "\n", _jsx(_components.h2, {
        id: "tips-and-troubleshooting",
        children: "Tips and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(CommonErrorsPreface, {}), "\n", "\n", _jsx(_components.h4, {
        id: "code-413-request-entity-too-large",
        children: "Code 413 \"Request Entity Too Large\""
      }), "\n", _jsxs(_components.p, {
        children: ["This error means that size of Hightouch's API request to Marketo was too large.\nLower the ", _jsx(_components.a, {
          href: "#batch-size",
          children: "batch size"
        }), " to mitigate it."]
      }), "\n", _jsx(_components.h4, {
        id: "code-603-access-denied",
        children: "Code 603 \"Access denied\""
      }), "\n", _jsxs(_components.p, {
        children: ["This error means that authentication to Marketo was successful but the account you authenticated with doesn't have sufficient permission to call the Marketo API.\nFor more information, see ", _jsx(_components.a, {
          href: "https://experienceleague.adobe.com/en/docs/experience-cloud-kcs/kbarticles/ka-29391",
          children: "Marketo's help article"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["As explained in the ", _jsx(_components.a, {
          href: "#create-marketo-service",
          children: "Create Marketo service"
        }), " section, ensure that:"]
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["you assigned all permissions listed in the table to the API access role (especially the ", _jsxs(_components.a, {
            href: "https://experienceleague.adobe.com/docs/marketo/using/product-docs/administration/users-and-roles/descriptions-of-role-permissions.html#access-api",
            children: [_jsx(_components.strong, {
              children: "Read-Write Activity"
            }), " permission"]
          }), "),"]
        }), "\n", _jsxs(_components.li, {
          children: ["and that the Marketo API user has access to the Marketo ", _jsx(_components.a, {
            href: "https://experienceleague.adobe.com/en/docs/marketo/using/product-docs/administration/workspaces-and-person-partitions/understanding-workspaces-and-person-partitions",
            children: "workspaces and partitions"
          }), " you want to use in Hightouch."]
        }), "\n"]
      }), "\n", _jsx(_components.h4, {
        id: "code-1003-campaign-is-not-part-of-a-program",
        children: "Code 1003 \"Campaign is not part of a program\""
      }), "\n", _jsx(_components.p, {
        children: "To resolve this error, move your campaign into a program."
      }), "\n", _jsx(_components.h4, {
        id: "code-1007-multiple-lead-match-lookup-criteria",
        children: "Code 1007 \"Multiple lead match lookup criteria\""
      }), "\n", _jsx(_components.p, {
        children: "To resolve this error, remove any duplicate rows with the same primary key in your model."
      }), "\n", _jsx(_components.h4, {
        id: "code-1013-record-not-found",
        children: "Code 1013 \"Record not found\""
      }), "\n", _jsxs(_components.p, {
        children: ["This error can happen if you select ", _jsx(_components.a, {
          href: "#supported-syncing",
          children: "Update mode"
        }), " when syncing to standard and custom objects. If a record doesn't exist in Marketo yet, you need to select ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "Upsert mode"
        }), " instead, which updates existing records and creates new ones, if needed."]
      }), "\n", "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
